<template>
  <div class="box">
    <tablePackaging
      :tableListData="postList"
      :tableOption.sync="tableOption"
      :isOperate="isOperate"
      :page="page"
      :searchFormList="searchFormList"
      @update="getTableChangePageData"
      @searchDate="getTableData"
      @deleteList="getDeleteList"
    >
      <template v-slot:header>
        <div class="btn-wrap">
          <div class="left-wrap">
            <el-button type="primary" @click="hitTheShelfClick" size="small"
              >上架</el-button
            >
            <el-button type="primary" @click="undercarriageClick" size="small"
              >下架</el-button
            >
          </div>
          <div class="right-wrap">
            <el-button type="primary" @click="handelClickAdd" size="small"
              >添加</el-button
            >
          </div>
        </div>
      </template>
      <template slot-scope="scope" slot="operate">
        <el-tooltip
          class="item"
          popper-class="popper-class"
          content="上架"
          placement="bottom-end"
        >
          <!-- v-if="scope.row.username != 'admin'" -->
          <el-button
            icon="el-icon-sell"
            circle
            size="20"
            type="success"
            @click="hitTheShelfClick([scope.row.visaBid])"
          ></el-button>
        </el-tooltip>
        <el-tooltip
          class="item"
          popper-class="popper-class"
          content="下架"
          placement="bottom-end"
        >
          <el-button
            icon="el-icon-sold-out"
            circle
            size="20"
            type="success"
            @click="undercarriageClick([scope.row.visaBid])"
          ></el-button>
        </el-tooltip>
        <el-tooltip
          class="item"
          popper-class="popper-class"
          content="编辑"
          placement="bottom-end"
        >
          <!-- v-if="scope.row.username != 'admin'" -->
          <el-button
            icon="el-icon-edit-outline"
            circle
            size="20"
            type="success"
            @click="handelClickEdit(scope.row)"
          ></el-button>
        </el-tooltip>
        <el-tooltip
          class="item"
          popper-class="popper-class"
          content="删除"
          placement="bottom-end"
        >
          <el-button
            icon="el-icon-delete"
            circle
            type="success"
            @click="handleDelete(scope.row)"
          ></el-button>
        </el-tooltip>
        <el-tooltip
          class="item"
          popper-class="popper-class"
          content="上移"
          placement="bottom-end"
        >
          <!-- v-if="scope.row.username != 'admin'" -->
          <el-button
            icon="el-icon-upload2"
            circle
            size="20"
            type="success"
            @click="upTransposition(scope.row)"
          ></el-button>
        </el-tooltip>
        <el-tooltip
          class="item"
          popper-class="popper-class"
          content="下移"
          placement="bottom-end"
        >
          <!-- v-if="scope.row.username != 'admin'" -->
          <el-button
            icon="el-icon-download"
            circle
            size="20"
            type="success"
            @click="downTransposition(scope.row)"
          ></el-button>
        </el-tooltip>
      </template>
    </tablePackaging>
    <visaAdd
      ref="visaAdd"
      :title="title"
      :visaBid="visaBid"
      @upData="getTableData"
    ></visaAdd>
  </div>
</template>

<script>
import {
  visaQuery,
  visaGrounding,
  visaUndercarriage,
  visaDelete,
  moveUp,
  moveDown,
} from '@/api/visa';
import tablePackaging from '@/components/tablePackaging';
import visaAdd from './components/visaAdd';
import { clone } from '@/utils/utils';
import { countryGetAll } from '@/api/country';
const defaultSearchObj = {
  pageNum: 1,
  pageSize: 10,
  categoryBid: '', //分类bid
  consularDistrictBid: '', //领区bid
  countryBid: '', //国家bid
  entriesBid: '', //入境次数bid
  maxPrice: '', //最大价格
  minPriice: '', //最小价格
  state: '', //签证状态:@-上架，1-下架
  visaName: '', //签证名称 categoryName
};
export default {
  data() {
    return {
      title: '新建签证',
      searchObj: clone(defaultSearchObj),
      postList: [],
      visaBid: '',
      searchFormList: [
        {
          lable: '签证名称', //请输入 + lable
          searchItem: 'visaName', //字段名
          type: 'input', //输入框类型
          value: '', //默认值
        },
        {
          lable: '所属国家', //请输入 + lable
          searchItem: 'countryBid', //字段名
          type: 'select', //输入选择框
          selectList: [], //下拉框列表
          selectValue: 'countryName', //名字
          selectId: 'countryBid', //发送后台的内容名字或id
          value: '', //默认值
        },
        {
          lable: '分类', //请输入 + lable
          searchItem: 'categoryBid', //字段名
          type: 'select', //输入选择框
          selectList: [], //下拉框列表
          selectValue: 'categoryName', //名字
          selectId: 'categoryBid', //发送后台的内容名字或id
          value: '', //默认值
        },
        {
          lable: '签证状态', //请输入 + lable
          searchItem: 'state', //字段名
          type: 'select', //输入选择框
          selectList: [
            {
              value: '上架',
              id: 0,
            },
            {
              value: '下架',
              id: 1,
            },
          ], //下拉框列表
          selectValue: 'value', //名字
          selectId: 'id', //发送后台的内容名字或id
          value: '', //默认值
        },
      ],
      isOperate: true,
      tableOption: [
        {
          type: 'selection',
          label: '#',
        },

        {
          prop: 'visaName',
          label: '签证名称',
          overHidden: true,
        },
        {
          prop: 'categoryName',
          label: '分类',
          overHidden: true,
        },
        {
          prop: 'consularDistrictName',
          label: '领区',
          overHidden: true,
        },
        {
          prop: 'countryName',
          label: '所属国家',
          overHidden: true,
        },
        {
          prop: 'entriesName',
          label: '入境次数',
          overHidden: true,
        },
        {
          prop: 'hadElectronicFormDesc',
          label: '是否关联申请表',
          overHidden: true,
        },
        {
          prop: 'electronicFormName',
          label: '电子申请表',
          overHidden: true,
        },
        {
          prop: 'price',
          label: '价格',
          overHidden: true,
        },
        {
          prop: 'stateDesc',
          label: '状态',
          overHidden: true,
        },
      ],
      page: {
        pageNum: 1, //起始位置
        pageSize: 10, //每页条数
        totalCount: null, //总条数
      },
      hitTheShelfList: {
        visaBids: [],
      },
    };
  },
  mounted() {
    this.getTableData();
    this.getInformationTypeFunc();
  },
  methods: {
    upTransposition(row) {
      moveUp(row.visaBid).then((res) => {
        if (res.code == 200) {
          this.$msg.success('操作成功！');
          this.getTableData();
        }
      });
      // if(row.rank -1  == 0){
      //   this.$msg('已经到顶了，无法上移！')
      // }
    },
    downTransposition(row) {
      moveDown(row.visaBid).then((res) => {
        if (res.code == 200) {
          this.$msg.success('操作成功！');
          this.getTableData();
        }
      });
    },
    getDeleteList(rows) {
      this.hitTheShelfList.visaBids = [];
      rows.forEach((item) => {
        this.hitTheShelfList.visaBids.push(item.visaBid);
      });
    },
    hitTheShelfClick(ids) {
      if (ids) {
        this.hitTheShelfList.visaBids = ids;
      }
      visaGrounding(this.hitTheShelfList).then((res) => {
        if (res.code == 200) {
          this.$msg.success('操作成功！');
          this.getTableData();
        }
      });
    },
    undercarriageClick(ids) {
      if (ids) {
        this.hitTheShelfList.visaBids = ids;
      }
      visaUndercarriage(this.hitTheShelfList).then((res) => {
        if (res.code == 200) {
          this.$msg.success('操作成功！');
          this.getTableData();
        }
      });
    },
    getInformationTypeFunc() {
      countryGetAll().then((res) => {
        if (res.code == 200) {
          //   this.countryList = res.data;
          this.searchFormList[1].selectList = res.data;
        }
      });
    },
    getTableData(obj) {
      if (obj) {
        this.searchObj = obj;
      }
      visaQuery(this.searchObj).then((res) => {
        if (res.code == 200) {
          console.log(res.data.records);
          this.postList = res.data.records;
          this.page.pageNum = res.data.pageNum;
          this.page.pageSize = res.data.pageSize;
          this.page.totalCount = res.data.total;
        }
      });
    },
    getTableChangePageData(obj) {
      this.searchObj.pageNum = obj.pageNum;
      this.searchObj.pageSize = obj.pageSize;
      this.getTableData();
    },
    handelClickAdd() {
      this.title = '新建签证';
      this.visaBid = '';
      this.$refs.visaAdd.DialogShow = true;
    },
    handelClickEdit(row) {
      this.title = '编辑签证';
      this.visaBid = row.visaBid;
      this.$refs.visaAdd.DialogShow = true;
    },
    handleDelete(row) {
      console.log(row.visaBid);
      this.$myConfirm
        .showMsgBox({
          title: '提示',
          // confirmBtnText: '一并删除',
          // cancelBtnText: '仅删除账号',
          tips: '',
          content: '确定删除该签证？',
        })
        .then(() => {
          visaDelete(row.visaBid).then((res) => {
            if (res.code == '200') {
              this.$msg.success('删除成功！');
              this.getTableData();
            }
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  components: {
    tablePackaging,
    visaAdd,
  },
};
</script>

<style lang="scss" scoped>
</style>